<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import { onMount } from 'svelte';
	import TextInput from './TextInput.svelte';
	import type { Component, Phone } from '@prisma/client';
	import type { TextInputConfig } from '$lib/config';
	import { Event } from '../../event';
	export let Config: Phone & Component;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	let Shown = Config.Shown;
	let textInputComp: TextInput;
	let Valid: boolean;
	export let SaveData: boolean = true;
	onMount(() => {});
	export function focus() {
		textInputComp.focus();
	}
	export async function validate() {
		return await textInputComp.validate();
	}
	export function setValid() {
		Event.trigger('phoneValidityChanged', true);
	}
	export function setInvalid() {
		Event.trigger('phoneValidityChanged', false);
	}
	export function setNuetral() {
		Event.trigger('phoneValidityChanged', false);
	}
	export function appendData(formData: FormData) {
		if (!SaveData) {
			formData.append('dont_save_columns', Config.DBCol + 'phone');
			return;
		}
		textInputComp.appendData(formData);
	}
	export function setValue(value: string) {
		textInputComp.setValue(value);
	}
	export function show() {
		Shown = true;
		textInputComp.show();
	}
	export function hide() {
		Shown = false;
		textInputComp.hide();
	}
	//If readonly changes then update the textInputComp
	$: {
		if (textInputComp) {
			//console.log('Phone.svelte ReadOnly:', ReadOnly);
			textInputComp.ReadOnly = ReadOnly;
		}
	}

	//If disabled changes then update the textInputComp
	$: {
		if (textInputComp) {
			//console.log('Phone.svelte Disabled:', Disabled);
			textInputComp.Disabled = Disabled;
		}
	}

	let ShowCount = false;
	let textInputConfig: TextInputConfig = {
		id: Config.id,
		sectionId: Config.sectionId,
		Order: Config.Order,
		createdAt: Config.createdAt,
		updatedAt: Config.updatedAt,
		EmptyMsg: Config.EmptyMsg,
		Desc: Config.Desc,
		MailChimpMergeField: Config.MailChimpMergeField,
		Shown: Config.Shown,
		componentId: Config.componentId,
		Type: 'TextInput',
		Required: Config.Required,
		DBCol: Config.DBCol + 'phone',
		Validator: 'USPhone',
		ShowCount: ShowCount,
		Mask: '(999) 999-9999',
		MaxLength: 100,
		Placeholder: '',
		Title: Config.Title,
		ReadOnly: ReadOnly,
		Disabled: Disabled
	};
</script>

<div class:hidden={!Shown}>
	<TextInput
		AutoComplete="tel"
		bind:this={textInputComp}
		InsideTitle={Config.Title ? Config.Title : 'Phone'}
		bind:Valid
		Config={textInputConfig}
		on:setInvalid={setInvalid}
		on:setValid={setValid}
		on:setNuetral={setNuetral}
	/>
</div>
